import React from 'react';
import ContentPage from '../components/ContentPage';
import { privacyPolicyBody, privacyPolicyTitle } from '../content/privacyPolicyContent';

function PrivacyPolicy() {
  return (
    <ContentPage
      title={privacyPolicyTitle}
      body={privacyPolicyBody}
    />
  );
}

export default PrivacyPolicy;
